import { StyleType } from '../types/shopConfig/shopConfigV2';
import { useShopConfig } from './shopConfig';

export const useStyleType = () => {
  const { styleType } = useShopConfig();
  const isCondensedStyle = styleType === StyleType.Condensed;
  return { isCondensedStyle };
};
